/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header';
import Footer from './sub_components/main/footer';
import * as userService from '../services/userService';
import * as affiliateService from '../services/affiliateService';
import * as apiUserService from '../services/apiUserService';
import { CSVLink } from 'react-csv';
import printJS from 'print-js';
import * as _ from 'lodash';
import * as userUtil from '../util/user.util';
import moment from 'moment';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { BASE_IMAGE_PATH_NEW } from '../configs/api';
let userListInterval
let linkClickTimeout
let printClickTimeout
class AffiliateReport extends Component {
   csvLink = React.createRef();
   constructor(props) {
      super(props);
      this.state = {
         uid: "",
         passcode: "",
         user_id: "",
         user_list: [],
         user_list_search: [],
         rg_user_list: {},
         pageLimit: 50,
         pageActive: 1,
         openPopup: "",
         selectedUser: "",
         currUserData: {},
         action: "",
         emptyClientList: false,
         shortFild: "username",
         shortType: "asc",
         searchText: "",
         showData: false,
         userDownlineList: [],
         userDownlineData: {},
         rgUserDownlineData: {},
         downline_user_id: "",
         select_downline_user_id: "",
         pdf_json: [],
         csv_json: [],
         isOfficeChannel: false,
         isOperator: false,
         allData: false,
         isOnlyClients: false,
         showClientParentSharing: false,
         selectedClientParentSharingUsr: "",
         affiliateReportList: [],
         affiliateReportListBKP: [],
         from: "",
         to: "",
         loader: false,
         totalTotalUserCount: 0,
         totalTotalDeposit: 0,
         totalTotalwithdraw: 0,
         totalTotalDepositCount: 0,
         totalTotalwithdrawCount: 0,
         totalTotalRegUsrDepositCount: 0,
         totalUser_total_pnl: 0,
      };
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }
   componentDidMount() {
      // this.getAffiliateClientLst();
      let userData = localStorage.getItem("tokenData")
      userData = JSON.parse(userData)
      if (!!userData) { //&& !!userData.user_role && userData.user_role === "Admin"
         let curDate = new Date().setHours(0, 0, 0, 0);
         let weekDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
         this.setState({ to: curDate, from: weekDate })
      } else {
         this.props.history.push('/dashboard');
      }
   }

   // getAffiliateClientLst() {
   //    const self = this;
   //    let tokenData = localStorage.getItem('tokenData');
   //    if (!!tokenData) {
   //       tokenData = JSON.parse(tokenData);
   //       let body = {
   //          "affiliateCode": !!tokenData.affilateCode ? tokenData.affilateCode : ''
   //       }
   //       affiliateService.getAffiliateClientList(body).then(async (result) => {
   //          if (!!result) {
   //             if (!!result.isSuccess) {
   //                self.setState({ affiliateReportList: result.data, showData: true });
   //             } else {
   //                self.props.notify(result.exception.message, "error")
   //             }
   //          }
   //       })
   //    }
   // }
   async componentDidMountTask() {
      const { match: { params } } = this.props;
      let tokenData = localStorage.getItem("tokenData")
      tokenData = JSON.parse(tokenData)
      let currUserData = localStorage.getItem("userAccData")
      currUserData = JSON.parse(currUserData)
      this.setState({ currUserData: currUserData, isOfficeChannel: (currUserData.username === 'office' || currUserData.parents.includes('office')), isOperator: currUserData.username === 'operator' })

   }
   componentWillUnmount() {
      // clearInterval(userListInterval)
      // clearTimeout(linkClickTimeout)
      // clearTimeout(printClickTimeout)
   }
   shortUser(fild, shortType, pageChange) {
      let userList = this.state.affiliateReportList
      if (!!userList) {
         // userList.sort((a, b) => (a["username"] > b["username"]) ? 1 : ((b["username"] > a["username"]) ? -1 : 0))
         // if (fild !== "pendingBalance") {
         userList.sort((a, b) => (a[fild] > b[fild]) ? 1 : ((b[fild] > a[fild]) ? -1 : 0))
         // } 
         // else {
         //    userList.sort((a, b) => (((!!a.creditRef ? a.creditRef : 0) - (!!a.balance ? a.balance : 0)) > ((!!b.creditRef ? b.creditRef : 0) - (!!b.balance ? b.balance : 0))) ? 1 : ((((!!b.creditRef ? b.creditRef : 0) - (!!b.balance ? b.balance : 0)) > ((!!a.creditRef ? a.creditRef : 0) - (!!a.balance ? a.balance : 0))) ? -1 : 0))
         // }
         if (shortType === "dasc") {
            userList = userList.reverse()
         }
         userList.sort(function (a, b) { return b.isActive - a.isActive });
      }
      this.setState({ affiliateReportList: [] }, () => {
         this.setState({ pageActive: !!pageChange ? 1 : this.state.pageActive, affiliateReportList: userList, shortFild: fild, shortType: shortType })
      })
   }
   async closeAndUpdate() {
      let tokenData = localStorage.getItem("tokenData")
      tokenData = JSON.parse(tokenData)
      if (!!this.state.downline_user_id) {
         this.setState({ openPopup: '' }, () => {
            this.onSelectedUser(this.state.downline_user_id);
         });
      } else {
         let users = await userService.getUsersVsOnlyClient(this.state.isOnlyClients)
         users = users.items
         // let rg_user_list = []
         // if(!!tokenData && !!tokenData.sub){
         //    rg_user_list = await userService.getRealGamesChildUsers(tokenData.sub)
         // }

         let rg_users = {};
         // if(rg_user_list.length > 0){
         //    for (let rg_usr of rg_user_list) {
         //       rg_users[rg_usr.username] = rg_usr;
         //    }
         // }

         this.setState({ user_list: [], rg_user_list: {} }, () => {
            this.setState({ user_list: users, rg_user_list: rg_users, openPopup: "" }, () => {
               this.shortUser(this.state.shortFild, this.state.shortType)
            })
         })
      }
   }
   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }

   async onPDFDownload(user_list_data, allData = false) {
      let pdf_json = []
      // if (Object.keys(this.state.userDownlineData).length > 0) {
      //    pdf_json.push(this.state.userDownlineData)
      // } else {
         pdf_json = user_list_data
      // }
      this.setState({ pdf_json: [] }, () => {
         this.setState({ pdf_json: pdf_json, allData: allData }, () => {
            printClickTimeout = setTimeout(function () {
               printJS({
                  printable: 'printJS-div',
                  type: 'html',
                  style: '@page { size: A4 landscape;}',
                  targetStyles: ['*']
               })
            }, 500)
         })
      })
   }


   async onDownload(user_list_data, alldata = false) {
      const self = this;
      
      this.setState({ csv_json: [] }, () => {
         let items = []
         
            let i = 0

            for (let x of user_list_data) {
               if (alldata ? true : (i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)))) {
                  let dictinory = {}

                  dictinory["User Name"] = x["username"]
                  dictinory["Name"] = x["name"]
                  dictinory["Mobile"] = x["mobile"]
                  dictinory["Registered User"] = x["totalUserCount"]
                  dictinory["NUDC"] = x["totalRegUsrDepositCount"]
                  dictinory["Total Deposit Amount"] = x["totalDeposit"]
                  dictinory["TDC"] = x["totalDepositCount"]
                  dictinory["Total Withdraw Amount"] = x["totalwithdraw"]
                  dictinory["TWC"] = x["totalwithdrawCount"]
                  dictinory["Total PNL"] = x["user_total_pnl"]
                  items.push(dictinory)
               }
               i += 1
            }

         this.setState({ csv_json: items }, () => {
            linkClickTimeout = setTimeout(function () {
               self.csvLink.current.link.click();
            }, 500)
         })
      })
   }

   onSearch(e) {
      this.setState({ searchText: e.target.value }, () => {
         this.filterlist(this.state.affiliateReportListBKP);
      })
   }

   async onUserSearch(e, name, value) {
      if (value.length > 1) {
         this.setState({ [name]: value })
         let res = await userService.getUserSearch(this.state.currUserData.username, value)
         let lst = []
         for (let x of res.usersList) {
            lst.push({ label: x, value: x, title: x, name: x })
         }
         lst.sort(function (a, b) {
            if (a.value.toLowerCase() < b.value.toLowerCase()) return -1;
            if (a.value.toLowerCase() > b.value.toLowerCase()) return 1;
            return 0;
         });
         this.setState({ userDownlineList: lst })
      }
      else if (value === "") {
         this.setState({ [name]: value, userDownlineList: [], select_downline_user_id: "", userDownlineData: {}, rgUserDownlineData: {} })
      }
      else {
         this.setState({ [name]: value, userDownlineList: [] })
      }
   }

   async onSelectedUser(user_id) {
      let userDetail = await apiUserService.getDashboard(user_id)
      // let rg_userDetail = await userService.getRealGamesUsersByUserName(user_id)

      this.setState({ userDownlineData: {}, rgUserDownlineData: {}, user_id: "" },
         () => {
            this.setState({ userDownlineData: userDetail, rgUserDownlineData: {}, select_downline_user_id: user_id, downline_user_id: user_id })
         }
      )
   }

   async changeActivation(user, isActive) {
      this.setState({ openPopup: "l", action: isActive ? "userUnlock" : "userLock", selectedUser: user })
   }
   async changeBlocking(user, isBlock) {
      this.setState({ openPopup: "l", action: isBlock ? "betLock" : "betUnlock", selectedUser: user })
   }
   onClientDownLine(usr) {
      localStorage.setItem(usr.username, JSON.stringify(usr))
      window.open("/affiliateReportList/" + usr.username, "_blank")
   }
   sum(array, key) {
      return array.reduce((a, b) => a + (b[key] || 0), 0);
   }
   filterUserData() {
      let userList = this.state.user_list
      const self = this
      if (this.state.searchText !== "" || this.state.searchText !== null || this.state.searchText !== undefined) {
         userList = _.filter(userList, function (obj) {
            return (self.state.isOnlyClients ? (obj['username'].toLowerCase().indexOf(self.state.searchText.toLowerCase()) !== -1 || (userUtil.getAppropriateParent(obj.parents, self.state.currUserData.username)).toLowerCase().indexOf(self.state.searchText.toLowerCase()) !== -1) : (obj.username.toLowerCase().indexOf(self.state.searchText.toLowerCase()) !== -1));
         });
      }
      return Object.assign([], userList)
   }

   onOnlyClientButtonClick() {
      clearInterval(userListInterval);
      this.setState({ isOnlyClients: !this.state.isOnlyClients, searchText: '', downline_user_id: '', select_downline_user_id: "", userDownlineData: {}, user_list: [], user_list_search: [], showData: false, pageActive: 1 }, () => {
         clearInterval(userListInterval);
         this.componentDidMountTask();
      });
   }

   onAction(e) {
      const name = e.target.name;
      if (name === "first") {
         this.setState({ pageActive: 1 })
      } else if (name === "prev") {
         this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive - 1) }))
      } else if (name === "next") {
         this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive + 1) }))
      } else if (name === "last") {
         this.setState({ action: name }, this.setState({ pageActive: Math.ceil(this.state.user_list.length / this.state.pageLimit) }))
      }
   }


   showClientParentSharing(usr) {
      this.setState({ selectedClientParentSharingUsr: usr.username, showClientParentSharing: true });
   }

   hideClientParentSharing() {
      this.setState({ selectedClientParentSharingUsr: "", showClientParentSharing: false });
   }

   removeAffiliateRequestRow(itm) {
      let affRequestLst = this.state.affiliateReportList;
      affRequestLst.splice(affRequestLst.indexOf(itm), 1);
      this.setState({ affiliateReportList: affRequestLst });
   }

   // onClientDownLine(usr) {
   //    localStorage.setItem(usr.username, JSON.stringify(usr))
   //    window.open("/clients/" + usr.username, "_blank")
   // }

   // onActivateDeactivateClick(item){
   //    const self = this;
   //    let param = {
   //       "username": item.username,
   //       "isActive": !item.isActive
   //    }
   //    affiliateService.updateAffiliateUserStatusApi(param).then((res) => {
   //       if (res.isSuccess) {
   //          self.props.notify(`${param.IsActive? 'Activated': 'Deavtivated'} successfully!`, "success");
   //          let lst = self.state.affiliateReportList;
   //          let index = -1
   //          for(let i=0; i< lst.length;i++){
   //             if(lst[i].username === param.username){
   //                index = i;
   //                break;
   //             }
   //          }
   //          if(index>-1){
   //             lst[index].isActive = param.IsActive;
   //             self.setState({affiliateReportList: lst});
   //          }

   //       } else {
   //          self.props.notify(res.exception.message, "error")
   //       }
   //    })
   // }


   onDateTimeChange(name, e) {
      this.setState({ [name]: e._d })
   }

   resetForm() {
      let curDate = new Date().setHours(0, 0, 0, 0);
      let weekDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ from: weekDate, to: curDate, showData: false })
   }
   onSubmit(e) {
      let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > 31) {
         this.props.notify("Date range must be 1 month.", "error");
      }
      else {
         this.setState({ action: "", page_no: 1, accounts: this.state.client_id, opening_balance: 0, first_id: "" }, () => { this.submitForm(); });
      }
   }

   parseFilterBody() {
      // let body = {
      //    "filters": {
      //       "user_ids": this.state.user_id,
      //       "types": this.state.types,
      //       "gameTypes": this.state.gameTypes,
      //       "client_ids": this.state.client_id
      //    },
      //    "last_id": this.state.last_id,
      //    "first_id": this.state.first_id,
      //    "action": this.state.action,
      //    "from": new Date(this.state.from).toISOString(),
      //    "to": new Date(this.state.to).toISOString(),
      //    "zone": new Date().getTimezoneOffset(),
      //    "page_no": this.state.page_no,
      //    "count_records": this.state.count_records,
      //    "opening_balance": this.state.page_no !== 1 ? this.state.opening_balance : 0,
      //    "closing_balance": this.state.closing_balance,
      //    "records_display": this.state.records_display,
      //    "current_balance": this.state.current_balance,
      //    "hst_balance": this.state.hst_balance
      // }
      let body = {
         "from": new Date(this.state.from).toISOString(),
         "to": new Date(this.state.to).toISOString()
      }
      body = this.clean(body);
      return body
   }

   async submitForm() {
      const self = this;
      let body = this.parseFilterBody()
      if(!!this.props.match.params.userId){
         body['userId'] = this.props.match.params.userId;
      }
      this.setState({ loader: true, showData: false })
      affiliateService.getAffiliateReport(body).then((result) => {
         if (!!result) {
            if (!!result.isSuccess) {
               self.filterlist(result.data);
               self.setState({ affiliateReportListBKP: result.data })
            } else {
               self.setState({ affiliateReportListBKP: [], affiliateReportList: [], showData: true, loader: false, totalTotalUserCount: 0, totalTotalDeposit: 0, totalTotalwithdraw: 0, totalTotalDepositCount: 0, totalTotalwithdrawCount: 0, totalTotalRegUsrDepositCount: 0, });
               self.props.notify(result.exception.message, "error")
            }
         }
      })
   }

   // affiliateReportListBKP

   filterlist(arr) {
      let ttlTotalUserCount = 0;
      let ttlTotalDeposit = 0;
      let ttlTotalwithdraw = 0;
      let ttlTotalDepositCount = 0;
      let ttlTotalwithdrawCount = 0;
      let ttlTotalRegUsrDepositCount = 0;
      let ttluser_total_pnl = 0;
      let arrlt = [];
      const search = this.state.searchText.toString().toLowerCase().trim(); 
      for (const itm of arr) {
         if (itm.username.toLowerCase().includes(search) || itm.name.toLowerCase().includes(search)) {
            arrlt.push(itm);
            ttlTotalUserCount = ttlTotalUserCount + itm.totalUserCount;
            ttlTotalDeposit = ttlTotalDeposit + itm.totalDeposit;
            ttlTotalwithdraw = ttlTotalwithdraw + itm.totalwithdraw;
            ttlTotalDepositCount = ttlTotalDepositCount + itm.totalDepositCount;
            ttlTotalwithdrawCount = ttlTotalwithdrawCount + itm.totalwithdrawCount;
            ttlTotalRegUsrDepositCount = ttlTotalRegUsrDepositCount + itm.totalRegUsrDepositCount;
            ttluser_total_pnl = ttluser_total_pnl + itm.user_total_pnl;
         }
      }

      this.setState({ 
         affiliateReportList: arrlt, 
         showData: true, 
         loader: false, 
         totalTotalUserCount: ttlTotalUserCount, 
         totalTotalDeposit: ttlTotalDeposit, 
         totalTotalwithdraw: ttlTotalwithdraw, 
         totalTotalDepositCount: ttlTotalDepositCount, 
         totalTotalwithdrawCount: ttlTotalwithdrawCount, 
         totalTotalRegUsrDepositCount: ttlTotalRegUsrDepositCount,
         totalUser_total_pnl:ttluser_total_pnl,
      });
   }

   getFilteredData(){
      let rtnvl = [...this.state.affiliateReportList];
      const search = this.state.searchText.toString().toLowerCase().trim(); 
      if(!!search){
         rtnvl = rtnvl.filter((itm)=> itm.username.toLowerCase().includes(search) || itm.name.toLowerCase().includes(search) || itm.mobile.includes(search) || (!!itm.affiliate_code ? itm.affiliate_code.includes(search) : false ))
      }
      return rtnvl;
   }

   formatNumber = (num) => {
    if (num === null || num === undefined) return '';

    return Number.isInteger(num)
      ? num.toString()
      : num.toFixed(2);
  };

   render() {
      let lst = []
      let affiliateRprtLst = this.getFilteredData()
      let total_page = Math.ceil(affiliateRprtLst.length / this.state.pageLimit)
      for (let x = 1; x <= total_page; x++) {
         if (this.state.pageActive === x || Math.abs(x - this.state.pageActive) <= 2 || (this.state.pageActive < 3 && x < 6) || (total_page - this.state.pageActive < 3 && total_page - x < 5)) {
            let htm = <button className={this.state.pageActive === x ? "btn btn-blue active pagewidth" : "btn btn-blue pagewidth"} key={"unsettle_btn_" + (x)} name="page_no" value={x} onClick={(e) => { { this.onAction(e) } this.setState({ pageActive: x }) }}>{x} </button>
            lst.push(htm)
         }
      }
      return (
         <div className="bethubs">
            <Header history={this.props.history} />
            <div className="wrapper">
               <div className="container-fluid container-padding-0">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="main-box">
                           <div>
                              <h5 className="text-blue  mb-2">
                                 <span>Affiliate Report</span>
                                 <div className="row user-header">
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                       <div className="form-group font-12">
                                          <Datetime
                                             value={this.state.from}
                                             onChange={(e) => this.onDateTimeChange("from", e)}
                                             id="from_datetime"
                                             dateFormat={"DD/MM/YYYY"}
                                             timeFormat={"HH:mm"}
                                          />
                                       </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                       <div className="form-group font-12">
                                          <Datetime
                                             value={this.state.to}
                                             onChange={(e) => this.onDateTimeChange("to", e)}
                                             id="to_datetime"
                                             dateFormat={"DD/MM/YYYY"}
                                             timeFormat={"HH:mm"}
                                          />
                                       </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                       <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                          <button className="btn btn-blue" disabled={!!this.state.from && !!this.state.to ? false : true} onClick={(e) => this.onSubmit(e)}>Go</button>
                                          <button className="btn btn-blue ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                       </div>
                                    </div>
                                    
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">

                                    </div>
                                    </div>
                                    <div className="row user-header">
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                       
                                       {/* <div className="form-group mb-0 d-inline">
                                          <input className="form-control  d-inline-block" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" value={this.state.searchText} />
                                       </div> */}
                                       <div className="d-flex float-left">
                                          <div className="form-group mb-0 d-inline">
                                             <input className="form-control  d-inline-block" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" value={this.state.searchText} />
                                          </div>
                                          <CSVLink
                                             data={this.state.csv_json}
                                             filename={"Affiliate Report.csv"}
                                             asyncOnClick={true}
                                             className="d-none"
                                             ref={this.csvLink}>
                                          </CSVLink>
                                          <button className="btn btn-sm d-inline csv-icon p-0 pl-1" title="Export Data" onClick={(e) => this.onDownload(this.state.affiliateReportList, true)} disabled={this.state.affiliateReportList.length > 0 ? false : true}><img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon.svg`}></img></button>
                                          <div style={{ display: "none" }}>
                                             <div id="printJS-div">

                                                <table id="exportall" className="table font-12 table-bordered table-sm w-100" style={{ border: "1px solid #000", color: "#212529", fontSize: '12px', width: '100%' }} >
                                                   <thead>
                                                      <tr>
                                                         <th>User Name</th>
                                                         <th>Name</th>
                                                         <th>Mobile</th>
                                                         <th>Registered User</th>
                                                         <th>NUDC</th>
                                                         <th>Total Deposit Amount</th>
                                                         <th>TDC</th>
                                                         <th>Total Withdraw Amount</th>
                                                         <th>TWC</th>
                                                         <th>Total PNL</th>
                                                      </tr>
                                                   </thead>
                                                   <tbody>
                                                      {this.state.pdf_json.length > 1 && this.state.pdf_json.map((usr, i) => {
                                                         return (<>
                                                            {/* {(this.state.allData ? true : i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1))) &&  */}
                                                               <tr>
                                                                  <td><span>{usr.username}</span></td>
                                                                  <td><span>{usr.name}</span></td>
                                                                  <td><span>{usr.mobile}</span></td>
                                                                  <td className='text-right'><span>{usr.totalUserCount}</span></td>
                                                                  <td className='text-right'><span>{usr.totalRegUsrDepositCount}</span></td>
                                                                  <td className='text-right'><span>{this.formatNumber(usr.totalDeposit)}</span></td>
                                                                  <td className='text-right'><span>{usr.totalDepositCount}</span></td>
                                                                  <td className='text-right'><span>{this.formatNumber(usr.totalwithdraw)}</span></td>
                                                                  <td className='text-right'><span>{usr.totalwithdrawCount}</span></td>
                                                                  <td className='text-right'><span>{this.formatNumber(usr.user_total_pnl)}</span></td>
                                                               </tr>
                                                      {/* } */}
                                                         </>
                                                         )
                                                      })
                                                      }
                                                   </tbody>
                                                </table>
                                             </div>
                                          </div>
                                          <button className="btn btn-sm pdf-icon d-inline p-0" title="Export Data" onClick={(e) => this.onPDFDownload(this.state.affiliateReportList, true)} disabled={this.state.affiliateReportList.length > 0 ? false : true}>
                                             <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon.svg`}></img>
                                          </button>
                                          {/* <button className="btn btn-sm d-inline csv-icon-all p-0 mx-2" title="Export All Data" onClick={(e) => this.onDownload(userList, true)} disabled={this.state.user_list.length > 0 ? false : true}>
                                             <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon-all.svg`}></img>
                                          </button>
                                          <button className="btn btn-sm pdf-icon-all d-inline p-0" title="Export All Data" onClick={(e) => this.onPDFDownload(userList, true)} disabled={this.state.user_list.length > 0 ? false : true}>
                                             <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon-all.svg`}></img>
                                          </button> */}
                                       </div>
                                    </div>
                                 </div>
                              </h5>
                           </div>

                           <div className="row mt-1">
                              
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12 table-responsive">
                                 {this.state.loader ?
                                    <span>Loading...</span>
                                    :
                                    (!!affiliateRprtLst && affiliateRprtLst.length > 0 ?
                                       <>
                                          <table id="example" className="table table-striped table-bordered table-sm addpadding nowrap" style={{ width: "100%" }}>
                                             <thead>
                                                <tr>
                                                   <th>Sr.</th>
                                                   <th>
                                                      <span>User Name</span>
                                                      <span className="d-contant" style={{ float: "right" }}>
                                                         <span onClick={() => { this.shortUser("username", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                         <span onClick={() => { this.shortUser("username", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                      </span>
                                                   </th>
                                                   <th>Name
                                                      <span className="d-contant" style={{ float: "right" }}>
                                                         <span onClick={() => { this.shortUser("name", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                         <span onClick={() => { this.shortUser("name", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                      </span>
                                                   </th>
                                                   <th>Mobile
                                                      <span className="d-contant" style={{ float: "right" }}>
                                                         <span onClick={() => { this.shortUser("mobile", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                         <span onClick={() => { this.shortUser("mobile", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                      </span>
                                                   </th>
                                                   <th>Registered User
                                                      <span className="d-contant" style={{ float: "right" }}>
                                                         <span onClick={() => { this.shortUser("totalUserCount", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                         <span onClick={() => { this.shortUser("totalUserCount", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                      </span>
                                                   </th>
                                                   <th>NUDC
                                                      <span className="d-contant" style={{ float: "right" }}>
                                                         <span onClick={() => { this.shortUser("totalRegUsrDepositCount", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                         <span onClick={() => { this.shortUser("totalRegUsrDepositCount", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                      </span>
                                                   </th>
                                                   <th>Total Deposit Amount
                                                      <span className="d-contant" style={{ float: "right" }}>
                                                         <span onClick={() => { this.shortUser("totalDeposit", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                         <span onClick={() => { this.shortUser("totalDeposit", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                      </span>
                                                   </th>
                                                   <th>TDC
                                                      <span className="d-contant" style={{ float: "right" }}>
                                                         <span onClick={() => { this.shortUser("totalDepositCount", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                         <span onClick={() => { this.shortUser("totalDepositCount", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                      </span>
                                                   </th>
                                                   <th>Total Withdraw Amount
                                                      <span className="d-contant" style={{ float: "right" }}>
                                                         <span onClick={() => { this.shortUser("totalwithdraw", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                         <span onClick={() => { this.shortUser("totalwithdraw", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                      </span>
                                                   </th>
                                                   <th>TWC
                                                      <span className="d-contant" style={{ float: "right" }}>
                                                         <span onClick={() => { this.shortUser("totalwithdrawCount", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                         <span onClick={() => { this.shortUser("totalwithdrawCount", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                      </span>
                                                   </th>
                                                   <th>Total PNL
                                                      <span className="d-contant" style={{ float: "right" }}>
                                                         <span onClick={() => { this.shortUser("user_total_pnl", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                         <span onClick={() => { this.shortUser("user_total_pnl", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                      </span>
                                                   </th>

                                                </tr>
                                             </thead>
                                             <tbody>
                                                {affiliateRprtLst.map((usr, i) => {
                                                   if (this.state.allData ? "" : i >= (this.state.pageLimit * this.state.pageActive) || (i + 1) <= (this.state.pageLimit * (this.state.pageActive - 1))) {
                                                      return false
                                                   }
                                                   return (
                                                      <>
                                                         {/* {i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)) && */}

                                                         <tr>
                                                            <td>{i+1}</td>
                                                            <td><a className='text-decoration-underline' href={`/affiliateReport/${usr.username}`} target='_blank'><span>{usr.username}</span></a></td>
                                                            <td><span>{usr.name}</span></td>
                                                            <td><span>{usr.mobile}</span></td>
                                                            <td className='text-right'><span>{usr.totalUserCount}</span></td>
                                                            <td className='text-right'><span>{usr.totalRegUsrDepositCount}</span></td>
                                                            <td className='text-right'><span>{this.formatNumber(usr.totalDeposit)}</span></td>
                                                            <td className='text-right'><span>{usr.totalDepositCount}</span></td>
                                                            <td className='text-right'><span>{this.formatNumber(usr.totalwithdraw)}</span></td>
                                                            <td className='text-right'><span>{usr.totalwithdrawCount}</span></td>
                                                            <td className='text-right'><span>{this.formatNumber(usr.user_total_pnl)}</span></td>
                                                         </tr>
                                                         {/* } */}
                                                      </>
                                                   )
                                                })}
                                                <tr>
                                                   <td className='font-weight-bold' colSpan={4}><span>Total</span></td>
                                                   <td className='text-right font-weight-bold'><span>{this.state.totalTotalUserCount}</span></td>
                                                   <td className='text-right font-weight-bold'><span>{this.state.totalTotalRegUsrDepositCount}</span></td>
                                                   <td className='text-right font-weight-bold'><span>{this.formatNumber(this.state.totalTotalDeposit)}</span></td>
                                                   <td className='text-right font-weight-bold'><span>{this.state.totalTotalDepositCount}</span></td>
                                                   <td className='text-right font-weight-bold'><span>{this.formatNumber(this.state.totalTotalwithdraw)}</span></td>
                                                   <td className='text-right font-weight-bold'><span>{this.state.totalTotalwithdrawCount}</span></td>
                                                   <td className='text-right font-weight-bold'><span>{this.formatNumber(this.state.totalUser_total_pnl)}</span></td>
                                                </tr>
                                             </tbody>
                                          </table> 
                                       </>
                                       :
                                       <span> No Record Found.</span>
                                    )
                                 }
                              </div>
                           </div>

                           {
                              affiliateRprtLst.length > 0 &&
                              <>
                                 <div className="row">
                                    <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {(this.state.pageLimit * (this.state.pageActive - 1)) + 1} to {(this.state.pageLimit * this.state.pageActive) < affiliateRprtLst.length ? (this.state.pageLimit * this.state.pageActive) : affiliateRprtLst.length} of {affiliateRprtLst.length} entries</span></div>
                                    <div className="col-12 col-sm-12 col-md-6">
                                       <div className="btn-group float-right" role="group" aria-label="Basic example" id="pagination-btn">
                                          <button type="button" className="btn btn-blue" id="PrevPage" name="first" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>First</button>
                                          <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>Prev</button>
                                          {lst}
                                          <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil(affiliateRprtLst.length / this.state.pageLimit) ? true : false}>Next</button>
                                          <button type="button" className="btn btn-blue" id="NextPage" name="last" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil(affiliateRprtLst.length / this.state.pageLimit) ? true : false}>Last</button>
                                       </div>
                                    </div>
                                 </div>
                              </>
                           }
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <Footer />
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(AffiliateReport);